import { VoucherFormBanner } from '../../components/VoucherForm/Banner';
import { VoucherFormBooking } from '../../components/VoucherForm/Booking';
import { VoucherFormProvider } from '../../components/VoucherForm/Context';
import { VoucherFormDiscount } from '../../components/VoucherForm/Discount';
import { VoucherFormInformation } from '../../components/VoucherForm/Information';
import { VoucherFormQuantity } from '../../components/VoucherForm/Quantity';
import { VoucherFormRulesTitle } from '../../components/VoucherForm/Rules';
import { VoucherFormBlackoutPeriod } from '../../components/VoucherForm/Rules/BlackoutPeriod';
import { VoucherFormCountriesAndLines } from '../../components/VoucherForm/Rules/CountriesAndLines';
import { VoucherFormTravelPeriod } from '../../components/VoucherForm/Rules/TravelPeriod';
import { VoucherFormTrips } from '../../components/VoucherForm/Rules/Trips';
import { VoucherFormStructure } from '../../components/VoucherForm/Structure';
import { VoucherFormSubmit } from '../../components/VoucherForm/Submit';

import styles from './add-voucher.module.scss';

const AddMarketingPage = () => {
  const template = {
    revenueType: 'Marketing',
    voucherType: 'Marketing',
    reasonField: false,
  };

  const DiscountTemplate = {
    disabled: false,
    discountType: 'percentage_marketing',
    excludeTypes: ['free_ride_hybrid', 'value_hybrid', 'credit_amount'],
    showFreeAncillaries: true,
  };

  const VoucherFormCountriesAndLinesTemplate = {
    allowedCountries: true,
    forbiddenCountries: true,
  };

  return (
    <>
      <VoucherFormBanner title='Marketing Voucher' />
      <VoucherFormProvider>
        <form>
          <div className={styles.container}>
            <VoucherFormInformation template={template} />
            <VoucherFormQuantity />
            <VoucherFormStructure />
            <VoucherFormDiscount template={DiscountTemplate} />
            <VoucherFormBooking />
          </div>
          <div className={styles.container}>
            <VoucherFormRulesTitle />
            <VoucherFormTrips />
            <VoucherFormCountriesAndLines template={VoucherFormCountriesAndLinesTemplate} />
            <VoucherFormTravelPeriod />
            <VoucherFormBlackoutPeriod />
          </div>
          <VoucherFormSubmit />
        </form>
      </VoucherFormProvider>
    </>
  );
};

export default AddMarketingPage;
